import axios from 'axios'
import config from '../../config';

const urls = {
	translates: '/admin/api/translit',
	persones: '/admin/api/people',
	personesShow: '/admin/api/people/show',
	personesImport: '/admin/api/people/import',
	personesImportUsers: '/admin/api/people/importUsers',
	companies: '/admin/api/companies',
	companiesImport: '/admin/api/companies/import',
	cities: '/admin/api/dictionaries/cities',
	courts: '/admin/api/dictionaries/courts',
	positions: '/admin/api/dictionaries/positions',
	feedbacks: '/admin/api/feedbacks',
	logout: '/admin/api/logout',
	login: '/admin/api/login',
	documents: '/admin/api/documents',
	home: '/admin/api/home',
	judgePerson: '/admin/api/search/judge-person-relation',
	judgeCompany: '/admin/api/search/judge-company-relation',
	documentsPerson: '/admin/api/documents/intersects/person-person',
	documentsCompany: '/admin/api/documents/intersects/person-company',
	listSearch: '/admin/api/people/list-for-select',
	companiesListSearch: '/admin/api/companies/list-for-select',

	// searchPersones: '/admin/api/documents/search-related-people',
	// searchDocuments: '/admin/api/documents/search',
	// searchCompany: '/admin/api/documents/search-related-company',
	// searchCompanyToCompany: '/admin/api/documents/search-related-company-to-company',
	// searchJudges: '/admin/api/documents/search-related-judge',
	// searchJudgesToCompany: '/admin/api/documents/search-related-judge-company',
	// searchJudgesToLawyers: '/admin/api/documents/search-related-judge-lawyer',
	// peopleCount: '/admin/api/search-people-counts',
	// companiesCount: '/admin/api/search-companies-counts'
};

const apiHandler = axios.create({
	baseURL: config.api
});

const api = {
	urls: urls,

	URL: (url) => {
		return urls[url]
	},

	get: (url, data = {}) => {
		return new Promise((resolve, reject) => {
			apiHandler.get(urls[url] ? urls[url] : url, data).then((response) => {
				resolve(response)
			}).catch((error) => {
				reject(error)
			});
		})
	},

	post: (url, data = {}) => {
		return new Promise((resolve, reject) => {
			apiHandler.post(urls[url] ? urls[url] : url, data).then((response) => {
				resolve(response)
			}).catch((error) => {
				reject(error)
			});
		})
	},

	put: (url, data = {}) => {
		return new Promise((resolve, reject) => {
			apiHandler.put(urls[url] ? urls[url] : url, data).then((response) => {
				resolve(response)
			}).catch((error) => {
				reject(error)
			});
		})
	},

	delete: (url, data = {}) => {
		return new Promise((resolve, reject) => {
			apiHandler.delete(urls[url] ? urls[url] : url, data).then((response) => {
				resolve(response)
			}).catch((error) => {
				reject(error)
			});
		})
	},

	getContext: () => {
		return apiHandler;
	}
};

export default api
